var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_svg__linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 135.9,
    y1: 312.59,
    x2: 298.34,
    y2: 312.59,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_svg__linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 141.9,
    y1: 312.59,
    x2: 292.34,
    y2: 312.59,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_svg__linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 135.9,
    y1: 260.79,
    x2: 298.34,
    y2: 260.79,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_svg__linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 141.9,
    y1: 260.79,
    x2: 292.34,
    y2: 260.79,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_svg__linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 135.9,
    y1: 208.99,
    x2: 298.34,
    y2: 208.99,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_svg__linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 141.9,
    y1: 208.99,
    x2: 292.34,
    y2: 208.99,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_svg__linear6",
    gradientUnits: "userSpaceOnUse",
    x1: 135.9,
    y1: 157.19,
    x2: 298.34,
    y2: 157.19,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_svg__linear7",
    gradientUnits: "userSpaceOnUse",
    x1: 141.9,
    y1: 157.19,
    x2: 292.34,
    y2: 157.19,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_svg__linear8",
    gradientUnits: "userSpaceOnUse",
    x1: 135.9,
    y1: 312.59,
    x2: 298.34,
    y2: 312.59,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_svg__linear9",
    gradientUnits: "userSpaceOnUse",
    x1: 141.9,
    y1: 312.59,
    x2: 292.34,
    y2: 312.59,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_svg__linear10",
    gradientUnits: "userSpaceOnUse",
    x1: 135.9,
    y1: 260.79,
    x2: 298.34,
    y2: 260.79,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_svg__linear11",
    gradientUnits: "userSpaceOnUse",
    x1: 141.9,
    y1: 260.79,
    x2: 292.34,
    y2: 260.79,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_svg__linear12",
    gradientUnits: "userSpaceOnUse",
    x1: 135.9,
    y1: 208.99,
    x2: 298.34,
    y2: 208.99,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_svg__linear13",
    gradientUnits: "userSpaceOnUse",
    x1: 141.9,
    y1: 208.99,
    x2: 292.34,
    y2: 208.99,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_svg__linear14",
    gradientUnits: "userSpaceOnUse",
    x1: 135.9,
    y1: 157.19,
    x2: 298.34,
    y2: 157.19,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_svg__linear15",
    gradientUnits: "userSpaceOnUse",
    x1: 141.9,
    y1: 157.19,
    x2: 292.34,
    y2: 157.19,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file_svg__surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_svg__linear0)"
    },
    d: "M 21.273438 24.191406 L 11.042969 24.191406 C 10.53125 24.191406 10.113281 23.773438 10.113281 23.261719 C 10.113281 22.753906 10.53125 22.335938 11.042969 22.335938 L 21.273438 22.335938 C 21.785156 22.335938 22.203125 22.753906 22.203125 23.261719 C 22.203125 23.773438 21.785156 24.191406 21.273438 24.191406 Z M 11.042969 23.226562 C 11.023438 23.226562 11.003906 23.242188 11.003906 23.261719 C 11.003906 23.28125 11.019531 23.296875 11.042969 23.296875 L 21.273438 23.296875 C 21.292969 23.296875 21.308594 23.28125 21.308594 23.261719 C 21.308594 23.242188 21.292969 23.226562 21.273438 23.226562 Z M 11.042969 23.226562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_svg__linear1)"
    },
    d: "M 11.042969 23.746094 L 21.273438 23.746094 C 21.539062 23.746094 21.757812 23.527344 21.757812 23.261719 C 21.757812 22.996094 21.539062 22.78125 21.273438 22.78125 L 11.042969 22.78125 C 10.777344 22.78125 10.558594 22.996094 10.558594 23.261719 C 10.558594 23.527344 10.777344 23.746094 11.042969 23.746094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_svg__linear2)"
    },
    d: "M 21.273438 20.335938 L 11.042969 20.335938 C 10.53125 20.335938 10.113281 19.917969 10.113281 19.410156 C 10.113281 18.898438 10.53125 18.480469 11.042969 18.480469 L 21.273438 18.480469 C 21.785156 18.480469 22.203125 18.894531 22.203125 19.410156 C 22.203125 19.921875 21.785156 20.335938 21.273438 20.335938 Z M 11.042969 19.371094 C 11.023438 19.371094 11.003906 19.386719 11.003906 19.410156 C 11.003906 19.429688 11.019531 19.441406 11.042969 19.441406 L 21.273438 19.441406 C 21.292969 19.441406 21.308594 19.425781 21.308594 19.410156 C 21.308594 19.390625 21.292969 19.371094 21.273438 19.371094 Z M 11.042969 19.371094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_svg__linear3)"
    },
    d: "M 11.042969 19.890625 L 21.273438 19.890625 C 21.539062 19.890625 21.757812 19.675781 21.757812 19.40625 C 21.757812 19.140625 21.539062 18.925781 21.273438 18.925781 L 11.042969 18.925781 C 10.777344 18.925781 10.558594 19.140625 10.558594 19.40625 C 10.558594 19.671875 10.777344 19.890625 11.042969 19.890625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_svg__linear4)"
    },
    d: "M 21.273438 16.480469 L 11.042969 16.480469 C 10.53125 16.480469 10.113281 16.066406 10.113281 15.554688 C 10.113281 15.042969 10.53125 14.625 11.042969 14.625 L 21.273438 14.625 C 21.785156 14.625 22.203125 15.042969 22.203125 15.554688 C 22.203125 16.066406 21.785156 16.480469 21.273438 16.480469 Z M 11.042969 15.519531 C 11.023438 15.519531 11.003906 15.535156 11.003906 15.554688 C 11.003906 15.574219 11.019531 15.589844 11.042969 15.589844 L 21.273438 15.589844 C 21.292969 15.589844 21.308594 15.574219 21.308594 15.554688 C 21.308594 15.535156 21.292969 15.519531 21.273438 15.519531 Z M 11.042969 15.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_svg__linear5)"
    },
    d: "M 11.042969 16.035156 L 21.273438 16.035156 C 21.539062 16.035156 21.757812 15.820312 21.757812 15.554688 C 21.757812 15.289062 21.539062 15.070312 21.273438 15.070312 L 11.042969 15.070312 C 10.777344 15.070312 10.558594 15.285156 10.558594 15.554688 C 10.558594 15.820312 10.777344 16.035156 11.042969 16.035156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_svg__linear6)"
    },
    d: "M 21.273438 12.625 L 11.042969 12.625 C 10.53125 12.625 10.113281 12.210938 10.113281 11.699219 C 10.113281 11.1875 10.53125 10.769531 11.042969 10.769531 L 21.273438 10.769531 C 21.785156 10.769531 22.203125 11.1875 22.203125 11.699219 C 22.203125 12.210938 21.785156 12.625 21.273438 12.625 Z M 11.042969 11.664062 C 11.023438 11.664062 11.003906 11.679688 11.003906 11.699219 C 11.003906 11.71875 11.019531 11.734375 11.042969 11.734375 L 21.273438 11.734375 C 21.292969 11.734375 21.308594 11.71875 21.308594 11.699219 C 21.308594 11.679688 21.292969 11.664062 21.273438 11.664062 Z M 11.042969 11.664062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_svg__linear7)"
    },
    d: "M 11.042969 12.179688 L 21.273438 12.179688 C 21.539062 12.179688 21.757812 11.964844 21.757812 11.699219 C 21.757812 11.429688 21.539062 11.214844 21.273438 11.214844 L 11.042969 11.214844 C 10.777344 11.214844 10.558594 11.429688 10.558594 11.699219 C 10.558594 11.964844 10.777344 12.179688 11.042969 12.179688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_svg__linear8)"
    },
    d: "M 21.273438 24.191406 L 11.042969 24.191406 C 10.53125 24.191406 10.113281 23.773438 10.113281 23.261719 C 10.113281 22.753906 10.53125 22.335938 11.042969 22.335938 L 21.273438 22.335938 C 21.785156 22.335938 22.203125 22.753906 22.203125 23.261719 C 22.203125 23.773438 21.785156 24.191406 21.273438 24.191406 Z M 11.042969 23.226562 C 11.023438 23.226562 11.003906 23.242188 11.003906 23.261719 C 11.003906 23.28125 11.019531 23.296875 11.042969 23.296875 L 21.273438 23.296875 C 21.292969 23.296875 21.308594 23.28125 21.308594 23.261719 C 21.308594 23.242188 21.292969 23.226562 21.273438 23.226562 Z M 11.042969 23.226562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_svg__linear9)"
    },
    d: "M 21.273438 23.746094 L 11.042969 23.746094 C 10.773438 23.746094 10.558594 23.527344 10.558594 23.261719 C 10.558594 22.996094 10.773438 22.78125 11.042969 22.78125 L 21.273438 22.78125 C 21.539062 22.78125 21.753906 22.996094 21.753906 23.261719 C 21.753906 23.527344 21.539062 23.746094 21.273438 23.746094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_svg__linear10)"
    },
    d: "M 21.273438 20.335938 L 11.042969 20.335938 C 10.53125 20.335938 10.113281 19.917969 10.113281 19.410156 C 10.113281 18.898438 10.53125 18.480469 11.042969 18.480469 L 21.273438 18.480469 C 21.785156 18.480469 22.203125 18.894531 22.203125 19.410156 C 22.203125 19.921875 21.785156 20.335938 21.273438 20.335938 Z M 11.042969 19.371094 C 11.023438 19.371094 11.003906 19.386719 11.003906 19.410156 C 11.003906 19.429688 11.019531 19.441406 11.042969 19.441406 L 21.273438 19.441406 C 21.292969 19.441406 21.308594 19.425781 21.308594 19.410156 C 21.308594 19.390625 21.292969 19.371094 21.273438 19.371094 Z M 11.042969 19.371094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_svg__linear11)"
    },
    d: "M 21.273438 19.890625 L 11.042969 19.890625 C 10.773438 19.890625 10.558594 19.675781 10.558594 19.40625 C 10.558594 19.140625 10.773438 18.925781 11.042969 18.925781 L 21.273438 18.925781 C 21.539062 18.925781 21.753906 19.140625 21.753906 19.40625 C 21.753906 19.671875 21.539062 19.890625 21.273438 19.890625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_svg__linear12)"
    },
    d: "M 21.273438 16.480469 L 11.042969 16.480469 C 10.53125 16.480469 10.113281 16.066406 10.113281 15.554688 C 10.113281 15.042969 10.53125 14.625 11.042969 14.625 L 21.273438 14.625 C 21.785156 14.625 22.203125 15.042969 22.203125 15.554688 C 22.203125 16.066406 21.785156 16.480469 21.273438 16.480469 Z M 11.042969 15.519531 C 11.023438 15.519531 11.003906 15.535156 11.003906 15.554688 C 11.003906 15.574219 11.019531 15.589844 11.042969 15.589844 L 21.273438 15.589844 C 21.292969 15.589844 21.308594 15.574219 21.308594 15.554688 C 21.308594 15.535156 21.292969 15.519531 21.273438 15.519531 Z M 11.042969 15.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_svg__linear13)"
    },
    d: "M 21.273438 16.035156 L 11.042969 16.035156 C 10.773438 16.035156 10.558594 15.820312 10.558594 15.554688 C 10.558594 15.289062 10.773438 15.070312 11.042969 15.070312 L 21.273438 15.070312 C 21.539062 15.070312 21.753906 15.285156 21.753906 15.554688 C 21.753906 15.820312 21.539062 16.035156 21.273438 16.035156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_svg__linear14)"
    },
    d: "M 21.273438 12.625 L 11.042969 12.625 C 10.53125 12.625 10.113281 12.210938 10.113281 11.699219 C 10.113281 11.1875 10.53125 10.769531 11.042969 10.769531 L 21.273438 10.769531 C 21.785156 10.769531 22.203125 11.1875 22.203125 11.699219 C 22.203125 12.210938 21.785156 12.625 21.273438 12.625 Z M 11.042969 11.664062 C 11.023438 11.664062 11.003906 11.679688 11.003906 11.699219 C 11.003906 11.71875 11.019531 11.734375 11.042969 11.734375 L 21.273438 11.734375 C 21.292969 11.734375 21.308594 11.71875 21.308594 11.699219 C 21.308594 11.679688 21.292969 11.664062 21.273438 11.664062 Z M 11.042969 11.664062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_svg__linear15)"
    },
    d: "M 21.273438 12.179688 L 11.042969 12.179688 C 10.773438 12.179688 10.558594 11.964844 10.558594 11.699219 C 10.558594 11.429688 10.773438 11.214844 11.042969 11.214844 L 21.273438 11.214844 C 21.539062 11.214844 21.753906 11.429688 21.753906 11.699219 C 21.753906 11.964844 21.539062 12.179688 21.273438 12.179688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%, 96.862745%, 96.862745%)",
      fillOpacity: 1
    },
    d: "M 23.949219 28.851562 L 8 28.851562 C 7.753906 28.851562 7.515625 28.753906 7.34375 28.582031 C 7.167969 28.40625 7.070312 28.167969 7.070312 27.925781 L 7.070312 3.980469 C 7.070312 3.734375 7.167969 3.496094 7.34375 3.324219 C 7.515625 3.148438 7.753906 3.050781 8 3.050781 L 19.535156 3.050781 C 19.777344 3.050781 20.015625 3.148438 20.191406 3.324219 L 24.605469 7.738281 C 24.777344 7.914062 24.878906 8.152344 24.878906 8.394531 L 24.878906 28.371094 L 24.761719 28.371094 C 24.722656 28.449219 24.667969 28.519531 24.605469 28.582031 C 24.433594 28.753906 24.195312 28.851562 23.949219 28.851562 Z M 8 3.945312 C 7.992188 3.945312 7.980469 3.949219 7.972656 3.953125 C 7.96875 3.960938 7.964844 3.972656 7.964844 3.980469 L 7.964844 27.925781 C 7.964844 27.933594 7.96875 27.945312 7.972656 27.949219 C 7.980469 27.957031 7.992188 27.960938 8 27.960938 L 23.023438 27.960938 L 23.023438 27.890625 L 8.035156 27.890625 L 8.035156 4.015625 L 19.519531 4.015625 L 23.914062 8.410156 L 23.914062 26.996094 L 23.984375 26.996094 L 23.984375 8.394531 C 23.984375 8.386719 23.980469 8.378906 23.972656 8.371094 L 19.558594 3.953125 C 19.550781 3.949219 19.542969 3.945312 19.53125 3.945312 Z M 8.925781 26.996094 L 23.023438 26.996094 L 23.023438 8.78125 C 23.023438 8.78125 19.148438 4.90625 19.148438 4.90625 L 8.925781 4.90625 Z M 8.925781 26.996094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%, 96.862745%, 96.862745%)",
      fillOpacity: 1
    },
    d: "M 23.949219 27.925781 L 23.949219 27.441406 L 8.480469 27.441406 L 8.480469 4.460938 L 19.332031 4.460938 C 19.332031 4.460938 21.402344 6.527344 21.402344 6.527344 L 23.46875 8.59375 L 23.46875 27.925781 L 23.949219 27.925781 L 23.949219 27.441406 L 23.949219 27.925781 L 24.433594 27.925781 L 24.433594 8.394531 C 24.433594 8.269531 24.382812 8.144531 24.289062 8.054688 L 19.875 3.640625 C 19.785156 3.550781 19.660156 3.496094 19.535156 3.496094 L 8 3.496094 C 7.871094 3.496094 7.746094 3.550781 7.65625 3.640625 C 7.566406 3.730469 7.515625 3.851562 7.515625 3.980469 L 7.515625 27.925781 C 7.515625 28.050781 7.566406 28.175781 7.65625 28.265625 C 7.746094 28.355469 7.871094 28.40625 8 28.40625 L 23.949219 28.40625 C 24.078125 28.40625 24.199219 28.355469 24.289062 28.265625 C 24.382812 28.175781 24.433594 28.050781 24.433594 27.925781 L 23.949219 27.925781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%, 96.862745%, 96.862745%)",
      fillOpacity: 1
    },
    d: "M 19.5625 9.164062 C 19.320312 9.164062 19.078125 9.066406 18.90625 8.894531 C 18.734375 8.722656 18.632812 8.480469 18.632812 8.238281 L 18.632812 4.117188 C 18.632812 3.601562 19.050781 3.1875 19.5625 3.1875 C 20.074219 3.1875 20.492188 3.605469 20.492188 4.117188 L 20.492188 7.308594 L 23.160156 7.308594 C 23.671875 7.308594 24.089844 7.726562 24.089844 8.238281 C 24.089844 8.746094 23.671875 9.164062 23.160156 9.164062 Z M 19.5625 9.164062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%, 96.862745%, 96.862745%)",
      fillOpacity: 1
    },
    d: "M 23.160156 7.753906 L 19.5625 7.753906 L 19.5625 8.238281 L 20.042969 8.238281 L 20.042969 4.113281 C 20.042969 3.847656 19.828125 3.632812 19.5625 3.632812 C 19.296875 3.632812 19.082031 3.847656 19.082031 4.113281 C 19.082031 6.570312 19.082031 8.238281 19.082031 8.238281 C 19.082031 8.363281 19.132812 8.488281 19.222656 8.578125 C 19.3125 8.667969 19.4375 8.71875 19.5625 8.71875 L 23.160156 8.71875 C 23.425781 8.71875 23.644531 8.503906 23.644531 8.238281 C 23.644531 7.96875 23.425781 7.753906 23.160156 7.753906 Z M 23.160156 7.753906 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.c328ed4e14be6f31cdf809b2726f84d1.svg";
export { ForwardRef as ReactComponent };